export function summarizeTableSituation(numberOfTables: number): string {
  if (numberOfTables === 0) {
    return "No tables";
  }
  if (numberOfTables === -1) {
    return "Probably";
  }
  if (numberOfTables === 1) {
    return "1 table";
  }
  return `${numberOfTables} tables`;
}
